module.exports = __webpack_public_path__ + "img/bantam.1c724c76.png";